<template>
  <EditorLayout
    class="skeleton-loader-container"
    :side-by-side-view="sideBySideView"
  >
    <template #full-width-header>
      <v-sheet
        height="56"
        class="w-100 d-flex justify-center ga-6"
      >
        <v-skeleton-loader
          v-for="(_, i) in Array(3)"
          :key="i"
          class="my-auto"
          type="heading"
          width="10%"
          height="14px"
        />
      </v-sheet>
    </template>

    <template #left>
      <SidebarSkeleton
        :animation-index="animationIndex"
        data-testid="sidebar-skeleton"
      />
    </template>

    <template #content>
      <EditorSkeleton
        :animation-index="animationIndex"
        :is-side-by-side-view="sideBySideView"
        :data-testid="sideBySideView ? 'editor-skeleton-sidebyside' : 'editor-skeleton-normal-view'"
      />
    </template>

    <template #side-revision>
      <EditorSkeleton
        :animation-index="animationIndex"
        :is-side-by-side-view="sideBySideView"
        data-testid="editor-skeleton-sidebyside"
      />
    </template>
  </EditorLayout>
</template>

<script>
import SidebarSkeleton from '@/components/shared/SkeletonLoaders/editor/SidebarSkeleton.vue';
import EditorSkeleton from '@/components/shared/SkeletonLoaders/editor/EditorSkeleton.vue';
import EditorLayout from '@/components/editor/EditorLayout.vue';

export default {
  name: 'EditorSkeletonLoader',
  components: {
    SidebarSkeleton,
    EditorSkeleton,
    EditorLayout,
  },
  props: {
    sideBySideView: { type: Boolean, default: false },
  },
  data() {
    return {
      animationIndex: 0,
    };
  },
  mounted() {
    this.incrementAnimation();
  },
  methods: {
    incrementAnimation() {
      if (this.animationIndex <= 4) {
        setTimeout(() => {
          this.animationIndex += 1;
          this.incrementAnimation();
        }, 0);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.skeleton-loader-container {
  .row {
    margin: 0;
  }
}

.skeleton-loader-container :deep(.skeleton path), :deep(.skeleton rect) {
  fill: @skeleton;
}

:deep(.skeleton .checkbox-skeleton-loader),
:deep(.v-skeleton-loader .v-skeleton-loader__heading),
:deep(.v-skeleton-loader .v-skeleton-loader__text) {
  background: rgb(var(--v-theme-bgDark));
}

.skeleton-title {
  width: 100%;
}

.skeleton-loader-container :deep(.v-skeleton-loader__heading) {
  width: 100%;
  margin: 0;
}

.skeleton-loader-container :deep(.v-skeleton-loader__text) {
  height: 20px;
  border-radius: 20px;
}

.skeleton-loader-container :deep(.v-skeleton-loader__paragraph) {
  .v-skeleton-loader__text:nth-child(2) {
    width: 100%;
    max-width: 100%;
  }
}

.skeleton-loader-container :deep(.v-skeleton-loader__paragraph) {
  .v-skeleton-loader__text:nth-child(3) {
    width: calc(100% - 75px);
    max-width: calc(100% - 75px);
  }
}

.skeleton-loader-container .skeleton-sub-heading :deep(.v-skeleton-loader__heading) {
  height: 20px;
}
</style>
